import type { ChannelName } from "./types";

export function prettyChannelName(name: ChannelName): string {
  if (name === undefined || name === null) {
    return "";
  }

  if (name === "twilio") {
    return "SMS";
  }

  if (name === "whatsapp") {
    return "WhatsApp";
  }

  return name
    .split("_")
    .map((word) => {
      return word[0]!.toUpperCase() + word.substring(1);
    })
    .join(" ");
}
